import { render } from "./Drive.vue?vue&type=template&id=55161b1c&ts=true"
import script from "./Drive.vue?vue&type=script&lang=ts"
export * from "./Drive.vue?vue&type=script&lang=ts"

import "./Drive.vue?vue&type=style&index=0&id=55161b1c&lang=css"

import exportComponent from "/home/kanbios/echo-v2/demo-front-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__